const inBrowser = typeof window !== 'undefined';

const empty = function(el) {
  return el.innerHTML = '';
}

const insertBefore = function(main, el) {
  main.parentNode.insertBefore(el, main);
}

const insertAfter = function(main, el) {
  var P = main.parentNode;     
  if(P.lastChild == main)
  {
    P.appendChild(main);
  }else
  {
    P.insertBefore(el, main.nextSibling);
  } 
}

const getDom = (ele) => {
  if (ele instanceof HTMLElement) {
    return ele;
  }

  return null;
}

const append = (parentId, child) => {

  let parent = document.getElementById(parentId);

  if (!parent) {
    parent = getDom(parentId);
  }

  if (parent) {
    parent.appendChild(child);
  }

}

const appendIf = function(main, el) {
  el.parentNode ? el.parentNode.removeChild(el) : null;
  return main.appendChild(el);
}

const appendOnly = function(main, el) {
  if (el.parentNode) {
    return;
  }
  return main.appendChild(el);
}

const m = {
  empty,
  insertBefore,
  insertAfter,
  append,
  appendIf,
  appendOnly,
}

module.exports = m;